const CHECKOUT_CAMPAIGN_PREFIX = 'RecoveryCheckout';
const CONSUMED_KEY_PREFIX = 'checkoutLinkConsumed';

export const CheckoutLinkService = () => {
    const isCheckoutLink = () => {
        const campaign = new URLSearchParams(window.location.search).get('utm_campaign') ?? '';

        return campaign.startsWith(CHECKOUT_CAMPAIGN_PREFIX);
    };

    const isConsumed = (fid) => sessionStorage.getItem(`${CONSUMED_KEY_PREFIX}:${fid}`) === '1';

    const markConsumed = (fid) => sessionStorage.setItem(`${CONSUMED_KEY_PREFIX}:${fid}`, '1');

    const shouldContinueToCheckout = (fid) => Boolean(fid) && isCheckoutLink() && !isConsumed(fid);

    return {
        isCheckoutLink,
        markConsumed,
        shouldContinueToCheckout,
    };
};
